import React, { useEffect, useState } from 'react';
import { types as sdkTypes } from '../../util/sdkLoader';

import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  InlineTextButton,
  NamedLink,
  Page,
  ResponsiveImage,
  Modal,
  IconSpinner,
} from '../../components';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './WinePage.module.css';
import wineImg from './wine.png';
import AboutWine from './AboutWine/AboutWine';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { ensureListing } from '../../util/data';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/UI.duck';
import { formatMoney } from '../../util/currency';
import { slugify } from '../../util/slugify';
import { addToStorage } from '../../util/cartStorage';
import config from '../../config';
import { loadData } from '../CartPage/CartPage.duck';

const { UUID } = sdkTypes;

const WinePage = ({
  params,
  showListingError,
  scrollingDisabled,
  onManageDisableScrolling,
  currentUser,
  wine,
  showListingLoading: wineLoading,
  intl,
  history,
}) => {
  const dispatch = useDispatch();
  const { slug, id } = params;
  const wineTitle =
    wine?.attributes?.publicData?.vintage !== undefined
      ? wine?.attributes?.publicData?.vintage + ' ' + wine?.attributes.title
      : `NV ${wine?.attributes.title}`;
  const wineryName = wine?.attributes?.publicData?.wineryName;
  const wineryId = wine?.attributes?.publicData?.wineryId;
  const wineType =
    wine?.attributes?.publicData?.type !== undefined ? wine?.attributes.publicData.type : '';
  const wineState =
    wine?.attributes?.publicData?.state !== undefined ? wine?.attributes.publicData.state : '';
  const winerySlug = slugify(wineryName);

  const [open, setOpen] = useState(false);

  const firstImage = wine?.images && wine?.images.length > 0 ? wine?.images[0] : null;

  // The Formula is: [State] > [Wine Type] > [Winery] > [Wine Name]
  const bannerTitle = wineState + ' > ' + wineType + ' > ' + wineryName + ' > ' + wineTitle;
  const formattedPrice = () => {
    if (wine.attributes.price) {
      return formatMoney(intl, wine?.attributes.price);
    }
  };

  const currentStock = wine?.currentStock?.attributes?.quantity;
  const isOutOfStock = config.listingManagementType === 'stock' && currentStock === 0;

  const messageId = intl.formatMessage({ id: 'OrderPanel.ctaButtonMessageNoStock' });

  const [quantity, setQuantity] = useState(isOutOfStock ? 0 : 1);
  console.log('WinePage', wine);
  return (
    <Page title="Wine Page" scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          {wineLoading ? (
            <div className={css.spinnerWrapper}>
              <IconSpinner />
            </div>
          ) : (
            <>
              <div className={css.wineBanner}>
                <div className={css.wineBannerWrapper}>
                  <div className={css.wineBannerContent}>
                    {bannerTitle && <p>{bannerTitle}</p>}
                    {wineryId && winerySlug ? (
                      <NamedLink name="Winery" params={{ slug: winerySlug, id: wineryId }}>
                        {wineryName && <h4>{wineryName}</h4>}
                      </NamedLink>
                    ) : null}
                    {wineTitle && <h2>{wineTitle}</h2>}

                    <span>{formattedPrice()}</span>

                    <div
                      style={{
                        display: 'inline-block',
                        marginLeft: '30px',
                      }}
                    >
                      <InlineTextButton
                        onClick={() => {
                          setQuantity(quantity - 1);
                        }}
                        rootClassName={css.wineBtnQuantity}
                        disabled={quantity <= 1}
                      >
                        -
                      </InlineTextButton>
                      <InlineTextButton rootClassName={css.wineBtnQuantity}>
                        {quantity}
                      </InlineTextButton>
                      <InlineTextButton
                        onClick={() => {
                          setQuantity(quantity + 1);
                        }}
                        disabled={currentStock == quantity}
                        rootClassName={css.wineBtnQuantity}
                      >
                        +
                      </InlineTextButton>
                    </div>

                    <div>
                      <InlineTextButton
                        onClick={() => {
                          addToStorage({
                            id: wine.id.uuid,
                            quantity,
                            isOwnListing: wine?.author?.id?.uuid === currentUser?.id?.uuid || false,
                            wineryId: wine.attributes.publicData.wineryId,
                          });
                          dispatch(loadData(undefined, {}));
                        }}
                        disabled={isOutOfStock}
                        rootClassName={css.wineBannerBtn}
                      >
                        {/* <NamedLink
                          name="ListingPage"
                          params={{slug, id}}
                        > */}
                        {isOutOfStock ? messageId : 'Add to Cart'}
                        {/* </NamedLink> */}
                      </InlineTextButton>
                    </div>
                  </div>
                  <div className={css.imgWrapper}>
                    <ResponsiveImage
                      rootClassName={css.rootForImage}
                      alt={wineTitle}
                      image={firstImage}
                      variants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
                      sizes="(max-width: 767px) 100vw, 80vw"
                    />
                  </div>
                </div>
              </div>
              <div className={css.aboutWineWrapper}>
                <AboutWine wine={wine} />
              </div>
            </>
          )}
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>

      <Modal
        id="ecomcommingsoon"
        isOpen={open}
        onClose={() => setOpen(false)}
        // usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <div className={css.modelWrapper}>
          Buying wine direct from your favorite boutique wineries is coming soon! Thank you for your
          patience.
        </div>
      </Modal>
    </Page>
  );
};

const mapStateToProps = state => {
  // const { isAuthenticated } = state.Auth;

  const { currentUser } = state.user;
  const { showListingError, id, showListingLoading } = state.WinePage;

  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };
  const wine = ensureListing(getListing(id));

  return {
    currentUser,
    showListingLoading,
    wine,
    scrollingDisabled: isScrollingDisabled(state),
    showListingError,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(WinePage);
